import {searchFromResort, searchFromPrefecture, searchFromArea} from './SearchHelper';
import { ISuggestion, YadoYadoCandidateHash, YadoResortCandidateHash, PrefectureCandidateHash, AreaCandidateHash } from '../../types';

function searchYadoByName(keyword: string, locale: string, yadoCandidates: YadoYadoCandidateHash, resortCandidates: YadoResortCandidateHash, prefecutreCandidates: PrefectureCandidateHash): ISuggestion[] {
  let nameLocaleResult: ISuggestion[] = [];
  let nameEnResult: ISuggestion[] = [];
  let otherResult: ISuggestion[] = [];

  for (let [key, value] of Object.entries(yadoCandidates)) {
    let _value = <ISuggestion>{
      type: "yado",
      id: key,
      label: value["name"][locale],
      isRecommented: value["is_recommended"]
    }

    if (value["name"][locale].indexOf(keyword) != -1) {
      nameLocaleResult.push(_value);
      continue;
    }
    if (value["name"]["en"].toLowerCase().indexOf(keyword) != -1) {
      nameEnResult.push(_value);
      continue;
    }
    if (value["resort_codes"].some((resortCode) => resortCode.indexOf(keyword) != -1 || resortCandidates[resortCode]["name"]["en"].indexOf(keyword) != -1 || resortCandidates[resortCode]["name"][locale].indexOf(keyword) != -1) ||
        value["prefecture_codes"].some((prefectureCode) => prefectureCode.indexOf(keyword) != -1 || prefecutreCandidates[prefectureCode]["name"]["en"].indexOf(keyword) != -1 || prefecutreCandidates[prefectureCode]["name"][locale].indexOf(keyword) != -1)) {
      otherResult.push(_value);
    }
  }
  return nameLocaleResult.concat(nameEnResult).concat(otherResult);
}

function searchYadoFromResort(keyword: string, locale: string, resortCandidates: YadoResortCandidateHash, prefecutreCandidates: PrefectureCandidateHash, areaCandidates: AreaCandidateHash): ISuggestion[] {
  return searchFromResort(keyword, locale, resortCandidates, prefecutreCandidates, areaCandidates).map( resultJson =>
    <ISuggestion>{
      type: "resort",
      id: resultJson["code"],
      label: resultJson["name"][locale]
    }
  )
}

function searchYadoFromPrefecture(keyword: string, locale: string, prefecutreCandidates: PrefectureCandidateHash): ISuggestion[] {
  return searchFromPrefecture(keyword, locale, prefecutreCandidates).map( resultJson =>
    <ISuggestion>{
      type: "prefecture",
      id: resultJson["code"],
      label: resultJson["name"][locale]
    }
  )
}

function searchYadoFromArea(keyword: string, locale: string, areaCandidates: AreaCandidateHash): ISuggestion[] {
  return searchFromArea(keyword, locale, areaCandidates).map( resultJson =>
    <ISuggestion>{
      type: "area",
      id: resultJson["code"],
      label: resultJson["name"][locale]
    }  
  )
}

export {
  searchYadoByName,
  searchYadoFromResort,
  searchYadoFromPrefecture,
  searchYadoFromArea,
};
